export default "__VITE_ASSET__DTMR3MCi__"